export function resolveHomeSide(teamCode, place, match) {
    if (!match) return null;
    if (teamCode && teamCode === match.home_team_code) return true;
    if (teamCode && teamCode === match.away_team_code) return false;
    if (place === 'home') return true;
    if (place === 'away') return false;
    return null;
}

function normalizeLineupPlayers(players) {
    if (!Array.isArray(players)) return [];
    const byId = new Map();

    players.forEach((p) => {
        if (!p || p.player_id == null || p.player_id === '') return;
        const id = String(p.player_id);
        const label = p.player_name || p.player_match_name || p.player_short || id;
        byId.set(id, { value: id, label });
    });

    return Array.from(byId.values()).sort((a, b) => a.label.localeCompare(b.label));
}

/** Players from /football/matches/{id}/extended → lineups (starters + subs for home or away). */
export function lineupPlayersForTeam(lineups, teamCode, match, place = '') {
    if (!match) return [];
    if (!lineups || Array.isArray(lineups) || typeof lineups !== 'object') return [];

    const isHome = resolveHomeSide(teamCode, place, match);
    if (isHome === null) return [];

    const starters = isHome ? lineups.home_team_starters : lineups.away_team_starters;
    const subs = isHome ? lineups.home_team_subs : lineups.away_team_subs;
    return normalizeLineupPlayers([...(starters || []), ...(subs || [])]);
}

export function hasUsableLineups(lineups) {
    if (!lineups || Array.isArray(lineups) || typeof lineups !== 'object') return false;
    const count =
        (lineups.home_team_starters || []).length +
        (lineups.away_team_starters || []).length +
        (lineups.home_team_subs || []).length +
        (lineups.away_team_subs || []).length;
    return count > 0;
}

export function withSelectedOption(options, selectedId, selectedLabel) {
    if (selectedId == null || selectedId === '') return options;
    const id = String(selectedId);
    if (options.some((o) => o.value === id)) return options;
    const label = selectedLabel || id;
    return [{ value: id, label }, ...options];
}

export function eventReasonSelectOptions(eventReasons, selectedId, selectedName) {
    const base = (eventReasons || []).map((r) => ({
        value: String(r.event_reason_id),
        label: r.event_reason_name,
    }));
    return withSelectedOption(base, selectedId, selectedName);
}

export function periodSelectOptions(periods, selectedId, selectedName) {
    const base = (periods || [])
        .map((p) => ({
            value: String(p.period_id),
            label: p.period_name,
        }))
        .sort((a, b) => Number(a.value) - Number(b.value));
    return withSelectedOption(base, selectedId, selectedName);
}

export function eventTypeSelectOptions(eventTypes, selectedId, selectedName) {
    const base = (eventTypes || [])
        .map((et) => ({
            value: String(et.event_type_id),
            label: et.event_type_name,
        }))
        .sort((a, b) => Number(a.value) - Number(b.value));
    return withSelectedOption(base, selectedId, selectedName);
}
